import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { checkBookingCondition } from "@utils";
import { CartModal, CartTimer } from "@components";
import { updateCart } from "@redux/booking/slice";
import "../../App.css";
import theme from "../../theme";

export default function CartsView() {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const prevCartRef = useRef();
  const { cartDetails } = useSelector((store) => store.bookingReducer);
  const { setting } = useSelector((store) => store.settingsReducer);
  const cartTimer = setting?.data?.checkoutTimer;

  const [countDownTime, setCountDownTime] = useState(cartTimer * 60);
  const [showTimer, setShowTimer] = useState(false);
  const [state, setState] = useState({
    cartModal: false,
    totalSelectedClub: 0,
  });
  const [isValid, setIsValid] = useState(false);

  const closeModal = () => {
    setState((prev) => ({ ...prev, cartModal: false }));
  };

  useEffect(() => {
    let localdata = JSON.parse(localStorage.getItem("C2H_LocalCartData"));
    if (localdata?.length && !cartDetails?.length) {
      dispatch(updateCart({ localdata: localdata, localSave: true }));
    }

    if (cartDetails?.length > 0) {
      localStorage.setItem("GolfCartStartTime", Date.now().toString());
      setShowTimer(true);

      let mergedMap = {};
      console.log('mergedMap-Start', mergedMap);
      cartDetails.forEach((item) => {
        if (!mergedMap[`${item?.clubId}-${item?.courseId?.courseId}`]) {
          mergedMap[`${item?.clubId}-${item?.courseId?.courseId}`] = {
            ...item,
          };
        } else {
          mergedMap[`${item?.clubId}-${item?.courseId?.courseId}`].players +=
            item?.players;
        }
      });
      console.log('mergedMap-End', mergedMap);

      let updated_CartDetail = Object.values(mergedMap);
      setState((prev) => ({
        ...prev,
        totalSelectedClub: updated_CartDetail.length,
      }));

      if (_.isEqual(prevCartRef.current, cartDetails)) {
        return;
      }
      prevCartRef.current = cartDetails;
      const checkCondition = async () => {
        const result = await checkBookingCondition(cartDetails, t, dispatch);
        setIsValid(result?.success === true);
      };

      checkCondition();
    }
  }, [cartDetails]);

  useEffect(() => {
    const storedStartTime = localStorage.getItem("GolfCartStartTime");

    if (storedStartTime) {
      const elapsedTime = Math.floor(
        (Date.now() - parseInt(storedStartTime, 10)) / 1000
      );
      const remainingTime = Math.max(cartTimer * 60 - elapsedTime, 0);

      // setCountDownTime(remainingTime);

      if (remainingTime === 0) {
        remove_AllItems();
        localStorage.removeItem("GolfCartStartTime");
      } else {
        setShowTimer(true);
      }
    } else {
      localStorage.setItem("GolfCartStartTime", Date.now().toString());
      setShowTimer(true);
    }
  }, []);

  useEffect(() => {
    if (countDownTime <= 0) {
      remove_AllItems();
      setShowTimer(false);
      localStorage.removeItem("GolfCartStartTime");
      return;
    }

    const interval = setInterval(() => {
      // setCountDownTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownTime]);

  const remove_AllItems = () => {
    if (window.location.pathname !== "/checkout") {
      dispatch(updateCart({ removeItem: true }));
      closeModal();
    }
  };

  return (
    <>
      {cartDetails?.length > 0 ? (
        <Content
          onClick={() => setState((prev) => ({ ...prev, cartModal: true }))}
        >
          {window.location.pathname !== "/checkout" && (
            <div className="sm:w-[90px] w-[82px]">
              <CartTimer />
            </div>
          )}
          <div className="w-[20px] h-[20px] mb-1">
            <ShoppingCartRoundedIcon sx={{ color: theme.colors.whiteText }} />
          </div>
          <div
            className={`w-auto min-w-[25px] px-[8px] flex items-center justify-center h-auto bg-white border rounded-full ${
              isValid ? "border-[green]" : "border-[red]"
            }`}
          >
            <span
              className={`text-[16px] font-semibold text-center ${
                isValid ? "text-[green]" : "text-[red]"
              }`}
            >
              {state.totalSelectedClub}
            </span>
          </div>
          {window.location.pathname !== "/checkout" && isValid && (
            <div className="w-[20px] h-[20px] flex items-center justify-center">
              <CheckCircleOutlineIcon sx={{ color: theme.colors.whiteText }} />
            </div>
          )}
        </Content>
      ) : (
        <></>
      )}
      <CartModal
        openModal={state.cartModal}
        closeModal={closeModal}
        addToCartData={cartDetails}
        showTimer={showTimer}
        removeAllItems={remove_AllItems}
      />
    </>
  );
}

const Content = tw.div`
w-auto 
h-[40px] 
rounded-full 
bg-buttonColor 
flex flex-row items-center xl:justify-around justify-center 
md:gap-x-2 gap-x-1 
md:px-4 px-2 
hover:cursor-pointer hover:opacity-80
`;
